import { render, staticRenderFns } from "./ButtonTab.vue?vue&type=template&id=02bb6fce&scoped=true"
import script from "./ButtonTab.vue?vue&type=script&lang=js"
export * from "./ButtonTab.vue?vue&type=script&lang=js"
import style0 from "./ButtonTab.vue?vue&type=style&index=0&id=02bb6fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb6fce",
  null
  
)

export default component.exports